import {v4 as uuid} from "uuid";

export const gameUUID = uuid();
export const getGameUUID = () => gameUUID;
